<script setup>
import { ref } from 'vue';
import Icon from 'next/icon/Icon.vue';
import { useSidebarContext } from './provider';

defineProps({
  label: { type: String, required: true },
  icon: { type: String, required: true },
  popup: { type: Object, required: true },
});

const { isCollapsed } = useSidebarContext();
const isOpen = ref(false);
</script>

<template>
  <li class="grid gap-1 text-sm cursor-pointer select-none min-w-0">
    <button
      v-if="isCollapsed"
      type="button"
      class="flex items-center justify-center size-10 rounded-lg"
      :class="
        isOpen
          ? 'text-n-slate-12 bg-n-alpha-2'
          : 'text-n-slate-11 hover:bg-n-alpha-2'
      "
      :title="label"
      @click="isOpen = true"
    >
      <Icon :icon="icon" class="size-4" />
    </button>
    <div
      v-else
      class="flex items-center gap-2 px-1.5 py-1 rounded-lg h-8 min-w-0"
      :class="
        isOpen
          ? 'text-n-slate-12 bg-n-alpha-2 font-medium'
          : 'text-n-slate-11 hover:bg-n-alpha-2'
      "
      role="button"
      draggable="false"
      :title="label"
      @click.stop="isOpen = true"
    >
      <div class="relative flex items-center gap-2">
        <Icon :icon="icon" class="size-4" />
      </div>
      <div class="flex items-center gap-1.5 flex-grow min-w-0 flex-1">
        <span class="truncate text-body-main">{{ label }}</span>
      </div>
    </div>
    <component :is="popup" v-if="isOpen" @close="isOpen = false" />
  </li>
</template>
